/* eslint-disable no-undef */
// -- JS for specific functions on taxiCentre contact us page

((document) => {
  window.addEventListener('load', () => {
    const tabLists = [{ selector: '.js-tabs-enquiry' }];
    const [enqTabs] = TabsAutomaticBuilder(tabLists);
    const tabLinks = document.querySelectorAll('.js-tabLink');
    let autoScroll = false;
    let targetTab = 0;
    tabLinks.forEach((tab) => {
      tab.addEventListener('click', (e) => {
        autoScroll = true;
        targetTab = e.target.dataset.tab;
        window.addEventListener('scrollend', () => {
          if (autoScroll) {
            autoScroll = false;
            enqTabs.resetTabIndex(targetTab);
          }
        });
      });
    });

    const salesThankYou = document.getElementById('js-taxi-sales-enq--thankyou');
    if (salesThankYou) {
      setTimeout(() => {
        salesThankYou.scrollIntoView();
        enqTabs.resetTabIndex(1);
      }, 200);
    }
  });

  document.querySelector('.js-startChat').addEventListener('click', () => {
    const webChatBubble = document.getElementById('webchatBubble');
    if (webChatBubble) {
      webchatBubble.click();
    }
  });
})(document);
